import {
  differenceInSeconds,
  endOfMonth,
  format,
  formatDuration,
  intervalToDuration,
  isPast,
  isThisWeek,
  isThisYear,
  isToday,
  startOfMonth,
  subMonths,
} from "date-fns";

export const getHoursAndMinutesFromSecs = (timeInSec: number) => {
  const hours = timeInSec >= 3600 ? Math.floor(timeInSec / 3600) : 0;
  const minutes = Math.ceil((timeInSec % 3600) / 60);

  return { hours, minutes };
};

export const getHoursAndMinutesFromMins = (timeInMin: number) => {
  const hours = timeInMin >= 60 ? Math.floor(timeInMin / 60) : 0;
  const minutes = Math.ceil(timeInMin % 60);

  return { hours, minutes };
};

export const getLastMonthDates = (date: Date, amount: number) => {
  const month = subMonths(date, amount);
  const startDate = startOfMonth(month);
  const endDate = endOfMonth(month);

  return { month, startDate, endDate };
};

export const formatInTwoDigits = (value: number | undefined) => {
  return value?.toString().padStart(2, "0") || "00";
};

export const getTimeUntilEvent = (startDate: Date, now: Date) => {
  const seconds = differenceInSeconds(startDate, now);
  const duration = intervalToDuration({ start: 0, end: seconds * 1000 });

  return `${formatInTwoDigits(duration.hours)}:${formatInTwoDigits(duration.minutes)}:${formatInTwoDigits(
    duration.seconds,
  )}`;
};

export interface Countdown {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  /** 0 once the start date is reached */
  totalSeconds: number;
}

/** Time left until `startDate`, including days (unlike `getTimeUntilEvent`). */
export const getCountdown = (startDate: Date, now: Date): Countdown => {
  const totalSeconds = Math.max(0, differenceInSeconds(startDate, now));
  return {
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
    totalSeconds,
  };
};

export const getDuration = (startDate: Date, endDate: Date) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const [earlier, later] = start <= end ? [start, end] : [end, start];
  const { seconds, ...rest } = intervalToDuration({ start: earlier, end: later });
  return formatDuration(rest);
};

// isPast(null) returned false in the old versions, now returns true
export const isInPast = (date: Date | undefined | null): boolean => {
  return date ? isPast(date) : false;
};

export function getDisplayLastMessageDate(lastMsgDate: Date): string {
  if (isToday(lastMsgDate)) {
    return format(lastMsgDate, "hh:mm a");
  }
  if (isThisWeek(lastMsgDate)) {
    return format(lastMsgDate, "EEE");
  }
  if (isThisYear(lastMsgDate)) {
    return format(lastMsgDate, "dd/MM");
  }
  return format(lastMsgDate, "dd/MM/yy");
}
